module.exports = __webpack_public_path__ + "static/media/delivery_simple.1bc50dcd.png";